<template>
  <button class="ml-auto p-3 bg-black-4 rounded-s hover:scale-[.95] transition-transform">
    <img src="/img/close.svg" class="w-5 h-5" />
  </button>
</template>
